import { Integration } from "src/app/backend/models/integration";
import { Installation } from "src/app/backend/models/installation";
import { Connection } from "src/app/backend/models/connection";

export enum ConnectIntegrationConnectionResultType {
  SUCCEED = "succeed",
  FAILED = "failed",
  CANCELED = "canceled"
}

export type ConnectIntegrationConnectionResult = {
  result: ConnectIntegrationConnectionResultType;
  connection?: Connection;
};

export type ConnectIntegrationInfo = {
  integration: Integration;
  installation: Installation;
  isRefresh?: boolean;
  refreshConnectionId?: string;
  phase: "install" | "execute";
};

export interface ConnectIntegrationConnector {
  connect(
    input: ConnectIntegrationInfo
  ): Promise<ConnectIntegrationConnectionResult>;
}
